import { createContext } from 'react';

export const TableRowHoverContext = createContext(true);
